module.exports = __webpack_public_path__ + "ca2f786013cfdf111800ae980561f14b.svg";